import { useState, useEffect } from "react";
import { QRCodeCanvas } from 'qrcode.react';

export default function FGSFGTemplate() {
    let printData = [];

    const rawPrintData = localStorage.getItem('printData') || localStorage.getItem('labelReprintData');

    if (rawPrintData) {
        const parsed = JSON.parse(rawPrintData);
        printData = Array.isArray(parsed)
            ? parsed
            : parsed?.printed_serials || [];
    }

    useEffect(() => {
        const hasPrinted = sessionStorage.getItem('hasPrinted');

        if (!hasPrinted) {
            window.print();
            sessionStorage.setItem('hasPrinted', true);
        }

        const timer = setTimeout(() => {
            window.close();
            window.location.reload();
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div id='content' style={{ fontSize: '13px',fontWeight: "500"}}>
            {printData.map((row, index) => (
                <div key={index} className="fg-sfg" style={{ height: '50mm', width: '75mm', pageBreakAfter: 'always', padding: '1mm' }}>
                    <center>
                        <span className="description" style={{ textAlign: 'center', fontWeight: "900", }}>{row.part_description}</span>
                    </center>

                    <div className="label-content" style={{ width: '75mm', display: 'flex', justifyContent: 'space-around', marginTop: '7px' }}>
                        <div className="print-area">
                            <span><strong>Part#:</strong> {row.part_number}</span> <br />
                            <span><strong>JTN#:</strong> {row.job_transaction_number}</span> <br />
                            <span><strong>PO#:</strong> {row.production_order_number}</span> <br />
                            <span><strong>SO#:</strong> {row.sales_order_number}</span> <br />
                            <span><strong>PR#:</strong> {row.reference}</span>
                        </div>
                        <div className="qr-section" style={{ fontSize: '10px', marginTop: '7px' }}>
                            <QRCodeCanvas id={`qr_code${index}`} size={60} value={row.serial_number} /> <br />
                            <span style={{ marginTop: "0.5mm", wordBreak: "break-all",fontSize: "13px", fontWeight: "600", }}>{row.serial_number}</span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
